/* eslint-disable react/no-array-index-key */
/* eslint-disable prefer-destructuring */
/* eslint-disable max-len */
// ==============================================
// ==================Import======================
// ==============================================

// ==================Hooks REACT===================

// ==================Actions===================

// ==================Style&IMG===================
import './style.scss';
import PropTypes from 'prop-types';

// ==================Components===================

function Group({ value }) {
  return (
    <div id="GroupContainer">
      <div key={value.id}>
        <p className="titleGroup">{value.value.title}</p>
        {value.value.table.map((elChild, tableIndex) => (
          <div key={`${value.id}-${tableIndex}`}>
            <p className="subtitleGroup">{elChild.table.table_caption}</p>
            {elChild.table.data.map((dataRow, rowIndex) => {
              const urlLink = (elChild.URL && elChild.URL[rowIndex] && elChild.URL[rowIndex].URL) || (elChild.Document && elChild.Document[rowIndex] && elChild.Document[rowIndex].Document && elChild.Document[rowIndex].Document.file) || '';
              return (
                <div className="tab" key={rowIndex}>
                  <p>{dataRow[0]}</p>
                  <p>{dataRow[1]}</p>
                  <p>
                    {urlLink ? (
                      <a
                        aria-hidden="true"
                        href={urlLink}
                        target="_blank"
                        rel="noreferrer"
                      >
                        {dataRow[2]}
                      </a>
                    ) : (
                      dataRow[2]
                    )}
                  </p>
                </div>
              );
            })}
          </div>
        ))}
      </div>
    </div>
  );
}

Group.propTypes = {
  value: PropTypes.shape({
    type: PropTypes.string.isRequired,
    id: PropTypes.string.isRequired,
    value: PropTypes.shape({
      title: PropTypes.string.isRequired,
      table: PropTypes.arrayOf(
        PropTypes.shape({}),
      ).isRequired,
    }).isRequired,
  }).isRequired,
};

export default Group;
